import React, { useContext, useEffect, useState } from 'react'
import logo from '../../../assets/svg/logo-dashboard-v1.png';
import { Link, useLocation } from 'react-router-dom';
import { RiDashboard2Line } from "react-icons/ri";
import { BiCategoryAlt, BiNotification, BiSolidAnalyse, BiSolidRegistered, BiStore, BiTask } from "react-icons/bi";
import { FiChevronRight, FiCreditCard, FiHeadphones, FiImage, FiMap, FiPackage, FiSettings, FiShoppingBag, FiTag, FiTruck, FiUserCheck } from "react-icons/fi";
import { MdPrecisionManufacturing, MdStore } from "react-icons/md";
import { FaTasks, FaUsers } from 'react-icons/fa';
import { CiShoppingCart } from 'react-icons/ci';
import { IoHomeOutline } from "react-icons/io5";
import { BsDatabaseAdd, BsHandbag } from "react-icons/bs";
import { RiBarChartBoxLine } from "react-icons/ri";
import { PiCreditCard } from "react-icons/pi";
import { TbAnalyze, TbDiscount2, TbFileAnalytics } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";
import logowrap from '../../../assets/images/Adidas-logo.png';
import { MdKeyboardArrowRight } from "react-icons/md";
import logogetto from '../../../assets/svg/logo-dashboard-v1.png'
import { checkUserPermissions } from '../../../helpers/permission';
import { getStoresListing } from '../../../api/context/manufacturer';
import { updateDetailsState } from '../../../atoms/updateDetails';
import { useRecoilState } from 'recoil';
import { FaImage } from "react-icons/fa";
import { MdOutlineBrandingWatermark } from "react-icons/md";
import { MdOutlineSupportAgent } from "react-icons/md";
import { FaGear, FaMotorcycle, FaRegImage, FaStore } from 'react-icons/fa6';



const Sidebar = () => {

    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user'));
    const [refresh] = useRecoilState(updateDetailsState);
    const [store, setStore] = useState([]);

    const getStoresDetails = () => {
        getStoresListing()((response) => {
            if (response?.statusCode == 200) {
                setStore(response?.data?.[0]);
            } else {
            }
        });
    };

    useEffect(() => {
        getStoresDetails()
    }, [refresh]);

    const userType = JSON.parse(localStorage.getItem('user'))?.userType;

    return (
        (<div className="app-menu navbar-menu">
            <div>
                <div className="navbar-brand-box">
                    <Link to={`${userType === 'customerSupport' ? "/chat-support" : "/"}`} className="logo logo-dark">
                        <span className="logo-sm">
                            <img src={logo} alt="" height={22} />
                        </span>
                        <span className="logo-lg">
                            <img src={logo} alt="" className='logo_tabs' />
                        </span>
                    </Link>

                    <button
                        type="button"
                        className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                        id="vertical-hover"
                    >
                        <i className="ri-record-circle-line" />
                    </button>
                </div>
                <div id="scrollbar">
                    <div className="container-fluid p-0">
                        <div id="two-column-menu" />
                        <ul className="navbar-nav" id="navbar-nav">

                            {checkUserPermissions('view_orders') &&
                                (<li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                                    <Link to={'/'} className="nav-link menu-link" >
                                        <IoHomeOutline /><span data-key="t-widgets">Dashboard</span>
                                    </Link>
                                </li>)
                            }

                            {checkUserPermissions('view_orders') && user?.userType === 'ADMIN' ? (
                                <li className={`nav-item ${location.pathname === '/analytics' ? 'active' : ''}`}>
                                    <Link to={'/analytics'} className="nav-link menu-link" >
                                        <TbFileAnalytics /><span data-key="t-widgets">Analytics</span>
                                    </Link>
                                </li>
                            ) : null}


                            {checkUserPermissions('view_banners') ?
                                <li className={`nav-item ${location.pathname === '/banner' ? 'active' : ''}`}>
                                    <Link to={'/banner'} className="nav-link menu-link" >
                                        <FiImage /><span data-key="t-widgets">Banner</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_banners') ?
                                <li className={`nav-item ${location.pathname === '/brand' || /^\/edit-brand-page\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/brand'} className="nav-link menu-link" >
                                        <MdOutlineBrandingWatermark /><span data-key="t-widgets">Brand</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_category') || checkUserPermissions('view_sub_category') ?
                                <li className={`nav-item ${location.pathname === '/categories' || /^\/sub-categories\/\d+$/.test(location.pathname) || /^\/create-sub-categories\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    {checkUserPermissions('view_category') ?
                                        <Link to={'/categories'} className="nav-link menu-link" >
                                            <BiCategoryAlt /><span data-key="t-widgets">Categories</span>
                                        </Link>
                                        :
                                        <></>
                                    }
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_products') ?
                                <li className={`nav-item ${location.pathname === '/inventory' || location.pathname === '/create-inventory' || /^\/edit-inventory\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/inventory'} className="nav-link menu-link" >
                                        <RiBarChartBoxLine /> <span data-key="t-widgets">Inventory</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_promocodes') ?
                                <li className={`nav-item ${location.pathname === '/promocodes' ? 'active' : ''}`}>
                                    <Link to={'/promocodes'} className="nav-link menu-link" >
                                        <TbDiscount2 /> <span data-key="t-widgets">Promocodes</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                              {/* {checkUserPermissions('view_promocodes') ?
                                <li className={`nav-item ${location.pathname === '/promocodes-page'  || location.pathname === '/create-promocodes'  || /^\/edit-promocodes\/\d+$/.test(location.pathname)  ? 'active' : ''}`}>
                                    <Link to={'/promocodes-page'} className="nav-link menu-link" >
                                        <TbDiscount2 /> <span data-key="t-widgets">Promocodes</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            } */}

                            {checkUserPermissions('view_manufacturer') ?
                                <li className={`nav-item ${location.pathname === '/vendors' || location.pathname === '/sync-category' || /^\/sync-inventory\/\d+$/.test(location.pathname) || /^\/edit-vendors\/\d+$/.test(location.pathname) || /^\/sync-category\/\d+$/.test(location.pathname) || /^\/map-category-size\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/vendors'} className="nav-link menu-link">
                                        <BiStore /> <span data-key="t-widgets">Vendors</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_orders') ?
                                <li className={`nav-item ${location.pathname === '/orders' || /^\/orderdetails\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/orders'} className="nav-link menu-link" >
                                        <FiShoppingBag /><span data-key="t-widgets">Orders</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_orders') && user?.userType === 'ADMIN' ? (
                                <li className={`nav-item ${location.pathname === '/tracking' ? 'active' : ''}`}>
                                    <Link to={'/tracking'} className="nav-link menu-link" >
                                        <FiMap /><span data-key="t-widgets">Tracking</span>
                                    </Link>
                                </li>
                            ) : null}

                               {checkUserPermissions('view_manufacturer') ?
                                <li className={`nav-item ${location.pathname === '/auto-notification'  ? 'active' : ''}`}>
                                    <Link to={'/auto-notification'} className="nav-link menu-link">
                                        <BiNotification /> <span data-key="t-widgets">Auto Notifications</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_orders') && user?.userType === 'ADMIN' ? (
                                <li className={`nav-item ${location.pathname === '/admin-settings' ? 'active' : ''}`}>
                                    <Link to={'/admin-settings'} className="nav-link menu-link" >
                                        <FiSettings /><span data-key="t-widgets">Settings</span>
                                    </Link>
                                </li>
                            ) : null}

                            {checkUserPermissions('view_payments') ?
                                <li className={`nav-item ${location.pathname === '/payments' ? 'active' : ''}`}>
                                    <Link to={'/payments'} className="nav-link menu-link" >
                                        <FiCreditCard /><span data-key="t-widgets">Payments</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }



                            {user?.userType === 'customerSupport' ?
                                <li className={`nav-item ${location.pathname === '/chat-support' ? 'active' : ''}`}>
                                    <Link to={'/chat-support'} className="nav-link menu-link" >
                                        <FiHeadphones /><span data-key="t-widgets">Chat Support</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            { (user?.userType !== 'customerSupport' && user?.userType !== 'ADMIN' && user?.userType !== 'Vendor') &&
                                
                                <li className={`nav-item ${location.pathname === '/register-vendor' ? 'active' : ''}`}>
                                <Link to={'/register-vendor'} className="nav-link menu-link" >
                                    <BiStore /> <span data-key="t-widgets">Registration</span>
                                </Link>
                            </li>
                            }


                            {/* {checkUserPermissions('view_supports') ? */}
                            <li className={`nav-item ${location.pathname === '/support' ? 'active' : ''}`}>
                                <Link to={'/support'} className="nav-link menu-link" >
                                    <FiHeadphones /> <span data-key="t-widgets">Getto Helpline</span>
                                </Link>
                            </li>



                            {checkUserPermissions('view_roles') || checkUserPermissions('view_users') ?
                                <li className="nav-item" id="sidebarUsers">
                                    <a className="nav-link menu-link" href="#sidebarUsers" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarUsers">
                                        <FiUserCheck />
                                        <span data-key="t-dashboards">User Management</span>
                                        <div className='collapse-icon'><FiChevronRight /></div>
                                    </a>
                                    <div className="collapse menu-dropdown" id="sidebarUsers">
                                        <ul className="nav nav-sm flex-column">
                                            {checkUserPermissions('view_roles') ?
                                                <li className="nav-item">
                                                    <Link to={'/roles'} className="nav-link" data-key="t-analytics">
                                                        Roles
                                                    </Link>
                                                </li>
                                                :
                                                <></>
                                            }
                                            {checkUserPermissions('view_users') ?
                                                <li className="nav-item">
                                                    <Link to={'/users'} className="nav-link" data-key="t-crm">
                                                        Users
                                                    </Link>
                                                </li>
                                                :
                                                <></>
                                            }
                                        </ul>
                                    </div>
                                </li>
                                :
                                <></>
                            }

                        </ul>
                    </div>
                </div>
            </div>
            {user?.userType === 'ADMIN' ?
                <Link className={`bottom_wrapper_sidebar ${location.pathname === '/my-profile' ? 'active' : ''}`} to='/my-profile'>
                    <div className='user_pro_wrapper'>
                        <div className='img_wrapper'>
                            <img src={logogetto} className='logo_img img-fluid' alt='Logo' />
                        </div>
                        <div className='content_wrapper'>
                            <h5>{user?.firstName}</h5>
                            <p>{user?.email}</p>
                        </div>
                    </div>
                    <div className='icon_wrapper'>
                        <MdKeyboardArrowRight className='icon' />
                    </div>
                </Link>
                :
                <Link className={`bottom_wrapper_sidebar ${location.pathname === '/my-profile' ? 'active' : ''}`} to='/my-profile'>
                    <div className='user_pro_wrapper'>
                        <div className='img_wrapper'>
                            <img src={store?.image ? store?.image : logogetto} className='logo_img img-fluid' alt={user?.firstName} />
                        </div>
                        <div className='content_wrapper'>
                            <h5>{user?.firstName}</h5>
                            <p>{user?.email}</p>
                        </div>
                    </div>
                    <div className='icon_wrapper'>
                        <MdKeyboardArrowRight className='icon' />
                    </div>
                </Link>
            }
            <div className="sidebar-background" />
        </div>)
    )
}

export default Sidebar